module.exports = __webpack_public_path__ + "static/media/2JPY.a161eee0.svg";